import React, { memo, useCallback } from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from 'components/ui/dialog';
import { Button } from 'components/ui/button';
import { ProfessionSelect } from '@app/components';
import { SelectOption } from 'components/Select';
import { Profession } from '@app/models';

interface ProfessionModalProps {
  visible: boolean;
  onChange: (value: SelectOption<Profession>) => void;
  onClose?: () => void;
  parentNumber?: number;
}

function ProfessionModal(props: ProfessionModalProps) {
  const { visible, onChange, onClose, parentNumber } = props;

  const onClickClose = useCallback(() => {
    if (onClose) {
      onClose();
    }
  }, [onClose]);

  return (
    <Dialog
      open={visible}
      onOpenChange={(open) => {
        if (!open) onClickClose();
      }}
    >
      <DialogContent className="max-w-2xl">
        <DialogHeader>
          <DialogTitle>Выберите сферу деятельности</DialogTitle>
        </DialogHeader>
        <div className="py-4">
          <ProfessionSelect onChange={onChange} parentNumber={parentNumber} />
        </div>
        <DialogFooter>
          <Button onClick={onClickClose}>Выбрать</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

export default memo(ProfessionModal);
